import { useEffect, useState } from 'react';
import { useFormik } from 'formik';

import { initialValues } from './formData';

import { cleanObj } from '../../../../../shared/utils/objects';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import { QuotationFilter } from '../../../../../shared/types/modules/quotation';

import {
    asyncGetLabelParams,
    asyncGetParams,
} from '../../../../../services/param.service';

export const usePqrQuotationFilters = (
    onFilter?: (data: QuotationFilter) => void
) => {
    const [typesDocument, setTypesDocument] = useState<ISelect[]>([]);
    const [typesQuotation, setTypesQuotation] = useState<ISelect[]>([]);
    const [bouquets, setBouquet] = useState<ISelect[]>([]);
    const [status, setStatus] = useState<ISelect[]>([]);
    const [typifications, setTypification] = useState<ISelect[]>([]);

    const onSubmit = (data: QuotationFilter) => {
        if (onFilter) onFilter(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        onSubmit,
    });

    useEffect(() => {
        asyncGetParams(ParamEnum.DOCUMENT_TYPE).then((params) =>
            setTypesDocument(params)
        );
    }, []);

    useEffect(() => {
        asyncGetLabelParams(ParamEnum.QUOTATION_TYPE).then((items) =>
            setTypesQuotation(items.map(({ name }) => ({ id: name, name })))
        );
    }, []);

    useEffect(() => {
        asyncGetLabelParams(ParamEnum.QUOTATION_BOUQUET).then((items) =>
            setBouquet(items.map(({ name }) => ({ id: name, name })))
        );
    }, []);

    useEffect(() => {
        asyncGetLabelParams(ParamEnum.QUOTATION_STATUS).then((items) =>
            setStatus(items.map(({ name }) => ({ id: name, name })))
        );
    }, []);

    useEffect(() => {
        asyncGetLabelParams(ParamEnum.QUOTATION_TYPIFICATION).then((items) =>
            setTypification(items.map(({ name }) => ({ id: name, name })))
        );
    }, []);

    return {
        formik,
        typesDocument,
        typesQuotation,
        bouquets,
        typifications,
        status,
    };
};
